import cx from "classnames"
import React, { Children } from "react"
import type { AllButtonsPropsType } from "./"
import Button from "./Button"
import DefaultButton from "./DefaultButton"
import GhostButton from "./GhostButton"
import InversedButton from "./InversedButton"

export interface ButtonsGroupProps {
  className?: string
  children: React.ReactNode
  align?: "fullWidth" | "right" | "center"
}

const isButton = (
  component: React.ReactNode,
): component is React.ReactElement<AllButtonsPropsType> =>
  React.isValidElement(component) &&
  (component.type === GhostButton ||
    component.type === GhostButton.Link ||
    component.type === InversedButton ||
    component.type === InversedButton.Link ||
    component.type === DefaultButton ||
    component.type === DefaultButton.Link ||
    component.type === Button)

const ButtonsGroup = ({ className, children, align }: ButtonsGroupProps) => (
  <div
    className={cx(className, "cobalt-buttons-group", {
      "cobalt-buttons-group--right": align === "right",
      "cobalt-buttons-group--center": align === "center",
    })}
  >
    {Children.toArray(children).map((child, index) => {
      if (!isButton(child)) {
        return child
      }
      const childKey =
        React.isValidElement(child) && child.key != null
          ? child.key
          : `button-group-item-${index}`
      return React.cloneElement(child, {
        key: childKey,
        className: cx("cobalt-buttons-group__item", {
          "cobalt-buttons-group__item--fullWidth": align === "fullWidth",
        }),
        fullWidth: align === "fullWidth",
      })
    })}
  </div>
)

export default ButtonsGroup
